// Main Carousel Variant
export const variants = {
    incoming: direction => ({
        x: direction > 0 ? '100%' : '-100%',
        y: '2rem',
        rotate: direction > 0 ? '10deg' : '-10deg',
        opacity: 0,
        zIndex: 1,
        scale: .9
    }),
    active: { x: 0, y: 0, rotate: '0deg', opacity: 1, zIndex: 2, scale: 1 },
    exit: direction => ({
        x: direction > 0 ? '-100%' : '100%',
        y: '2rem',
        rotate: direction > 0 ? '-10deg' : '10deg',
        opacity: 0,
        zIndex: 1,
        scale: .9
    }),
};

export const transition = {
    duration: 1,
    ease: [.56, .03, .12, 1.04]
};

// Prev/Next Variants
export const nextVariants = {
    incoming: direction => ({ 
        x: direction > 0 ? '125%' : 0, 
        y: direction > 0 ? '4rem' : 0, 
        rotate: direction > 0 ? '20deg' : '0deg',
        opacity: 0,
        zIndex: direction > 0 ? 0 : 1,
        scale: direction > 0 ? .8 : 1
    }),
    active: { opacity: .3, x: '100%', y: '2rem', rotate: '10deg', zIndex: 1, scale: .9},
    exit: direction => ({ 
        x: direction > 0 ? 0 : '125%', 
        y: direction > 0 ? 0 : '4rem', 
        rotate: direction > 0 ? '0deg' : '20deg', 
        opacity: 0,
        zIndex: direction > 0 ? 1 : 0,
        scale: direction > 0 ? 1 : .8
    })
}
export const prevVariants = {
    incoming: direction => ({ 
        x: direction > 0 ? 0 : '-125%', 
        y: direction > 0 ? 0 : '4rem', 
        rotate: direction > 0 ? '0deg' : '-20deg',
        opacity: 0,
        zIndex: direction > 0 ? 1 : 0,
        scale: direction > 0 ? 1 : .8
    }),
    active: { opacity: .3, x: '-100%', y: '2rem', rotate: '-10deg', zIndex: 1, scale: .9 },
    exit: direction => ({ 
        x: direction > 0 ? '-125%' : 0, 
        y: direction > 0 ? '4rem' : 0, 
        rotate: direction > 0 ? '-20deg' : '0deg',
        opacity: 0, 
        zIndex: direction > 0 ? 0 : 1,
        scale: direction > 0 ? .8 : 1
    })
}

// Product Name/Title Variants
export const nameVariants = {
    incoming: direction => ({ 
        opacity: 0, 
        x: direction > 0 ? '100%' : '-100%',
        y: 0,
    }),
    active: { opacity: 1, x: 0, y: 0 },
    exit: direction => ({ 
        opacity: 0,
        x: direction > 0 ? '-100%' : '100%',
        y: 0,
    })
}